import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useEmailDetail = (emailId) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["emailDetail", tenantVal, emailId],
    queryFn: async () => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/patientemail/get/${emailId}`
      );
      return response.data;
    },
    enabled: !!tenantVal && !!emailId,
  });
};
